import { FORM_SEVERITY_WARNING, type FormError, type FormSeverity } from '@eflight/shared/dist/common/formErrors';

import { getLabelForCountableShort } from '../../Datasource/CountableChanges/types';

// Severities and FormError live in @eflight/shared (the shared uplift check returns them).
export {
    FORM_SEVERITY_CAUTION,
    FORM_SEVERITY_WARNING,
    type FormError,
    type FormSeverity,
} from '@eflight/shared/dist/common/formErrors';

export type FormErrorLike = FormError | boolean | string;

export const getFormErrorSeverity = (formError: FormErrorLike): FormSeverity => {
    if (typeof formError === 'boolean') {
        return FORM_SEVERITY_WARNING;
    }
    if (typeof formError === 'string') {
        return FORM_SEVERITY_WARNING;
    }
    return formError.severity;
};

export const scrollToFirstError = () => {
    const errorElement = document.querySelector('*[data-has-error]');
    if (!errorElement) {
        return;
    }
    setTimeout(() => {
        errorElement.scrollIntoView({
            behavior: 'smooth',
        });
    }, 50); // allow for react redraw
};

export function confirmErrors(errors: { [key: string]: FormErrorLike }): boolean | null {
    const errorEntries = Object.entries(errors);
    if (errorEntries.length) {
        const errorText = errorEntries
            .map(([key, error]): string => {
                const errorText =
                    typeof error === 'string' ? error : typeof error === 'boolean' ? 'is unexpected value' : error.text;
                const label = getLabelForMaybeCountable(key);
                return `- ${label}: ${errorText}`;
            })
            .join('\n');
        return window.confirm(`Some values are unusual. Confirm you have double-checked them?\n\n${errorText}`);
    }
    return null;
}

function getLabelForMaybeCountable(countable: string): string {
    try {
        return getLabelForCountableShort(countable as any) ?? countable;
    } catch {
        return countable;
    }
}
